import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0173a695"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "right"
};
const _hoisted_2 = {
  class: "right_card1"
};
const _hoisted_3 = {
  class: "health-tit",
  style: {
    "color": "rgb(62, 202, 252)"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "police-type"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://rescommcdn.nbiotyun.com/res/kaiwan/custom-skin/skin1/red.gif",
  alt: "",
  class: "police-red"
}), /*#__PURE__*/_createElementVNode("img", {
  src: "https://rescommcdn.nbiotyun.com/res/kaiwan/custom-skin/skin1/yellow.gif",
  alt: "",
  class: "police-yellow"
})], -1));
const _hoisted_5 = {
  class: "handle-box"
};
const _hoisted_6 = {
  class: "police-today"
};
const _hoisted_7 = {
  class: "goAlarmList"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "今日报警", -1));
const _hoisted_9 = {
  class: "red-count"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "red-count-u"
}, " 起", -1));
const _hoisted_11 = {
  class: "police-today"
};
const _hoisted_12 = {
  class: "goAlarmList"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode("已处理 ("), /*#__PURE__*/_createElementVNode("span", null, "0%"), /*#__PURE__*/_createTextVNode(")")], -1));
const _hoisted_14 = {
  class: "red-count"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "red-count-u"
}, " 起", -1));
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"police-today\" data-v-0173a695><a class=\"goAlarmList\" data-v-0173a695><p data-v-0173a695>今日故障</p> <span class=\"yellow-count\" data-v-0173a695>0</span><span class=\"yellow-count-u\" data-v-0173a695> 起</span></a></div><div class=\"police-today\" data-v-0173a695><a class=\"goAlarmList\" data-v-0173a695><p data-v-0173a695>已处理 (<span data-v-0173a695>0%</span>)</p> <span class=\"yellow-count\" data-v-0173a695>0</span><span class=\"yellow-count-u\" data-v-0173a695> 起</span></a></div>", 2);
const _hoisted_18 = {
  class: "right_card2"
};
const _hoisted_19 = {
  class: "health-tit",
  style: {
    "color": "rgb(62, 202, 252)"
  }
};
const _hoisted_20 = {
  style: {
    "height": "100%",
    "color": "rgb(62, 202, 252)"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_Icon, {
    class: "icon",
    name: "Bell",
    style: {
      "padding-right": "10px"
    }
  }), _createTextVNode("报警监测 ")]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("a", _hoisted_7, [_hoisted_8, _createTextVNode(), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.data.alarmNum), 1), _hoisted_10])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("a", _hoisted_12, [_hoisted_13, _createTextVNode(), _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.data.alarmDealNum), 1), _hoisted_15])]), _hoisted_16])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_Icon, {
    class: "icon",
    name: "Bell",
    style: {
      "padding-right": "10px"
    }
  }), _withDirectives(_createElementVNode("textarea", {
    style: {
      "height": "50px"
    },
    class: "plantext",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.title = $event)
  }, null, 512), [[_vModelText, _ctx.title]])]), _createElementVNode("div", _hoisted_20, [_withDirectives(_createElementVNode("textarea", {
    class: "plantext",
    style: {
      "height": "600px",
      "width": "100%"
    },
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.content = $event)
  }, null, 512), [[_vModelText, _ctx.content]])])])]);
}